
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vzsuikhlndbxrhkmiehr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ6c3Vpa2hsbmRieHJoa21pZWhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgwOTg2MDIsImV4cCI6MjA1MzY3NDYwMn0.qGmbAlt30s13qN0UhMdUgSgG_EWYSk2MxXVWrHHxKuc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    headers: {
      'cache-control': 'no-cache'
    }
  }
});

// Tilføj en funktion til at nulstille Supabase klienten
export const resetSupabaseClient = () => {
  localStorage.removeItem('supabase.auth.token');
  window.location.reload();
};
